import { slidingWindow } from '~/lib/segment-patchup'
import { Wall, WallSegment } from './types'
import { Vector2Like } from 'three'

function approximatelyTheSame(a: Vector2Like, b: Vector2Like, epsilon: number = 0.1) {
  return Math.abs(a.x - b.x) < epsilon && Math.abs(a.y - b.y) < epsilon
}

export function wallIsValid(segments: Record<string, WallSegment>, wall: Wall) {
  const points = wall.segments.map(segment => segments[segment].startPoint)
  points.push(segments[wall.segments[wall.segments.length - 1]].endPoint)

  // no pairs within the polygon should be approximately the same, only at the beginning and end if this is a closed polygon
  return slidingWindow(points, 2).every(([a, b]) => !approximatelyTheSame(a, b))
}

export function wallIsClosed(segments: Record<string, WallSegment>, wall: Wall) {
  return approximatelyTheSame(
    segments[wall.segments[0]].startPoint,
    segments[wall.segments[wall.segments.length - 1]].endPoint
  )
}

export function wallIsValidAndPolygon(segments: Record<string, WallSegment>, wall: Wall) {
  return wallIsValid(segments, wall) && wallIsClosed(segments, wall)
}
